module.exports = __webpack_public_path__ + "media/images/twitter-icon-5ca6257f79fbb0527cf2661e4c9711c4.svg";